export const STORE_EXCHANGE_LABELS = {
  pageTitle: "Consulta de Trocas",
  pageDescription:
    "Consulte as trocas e devoluções registradas por loja e período",
  storeLabel: "Loja",
  storePlaceholder: "Selecione a loja",
  periodLabel: "Período",
  periodPlaceholder: "Selecione o período",
  statusLabel: "Situação",
  controlNumberLabel: "Nº do controle",
  controlNumberPlaceholder: "Ex.: 50911",
  customerDocumentLabel: "CPF do cliente",
  customerDocumentPlaceholder: "Com ou sem máscara",
  operatorLabel: "Operador",
  operatorPlaceholder: "Ex.: FELIPES",
  allOption: "Todas",
  searchButton: "Consultar",
  excelButton: "Gerar Excel",
  generating: "Gerando…",
  searching: "Consultando…",
  selectFiltersHint: "Selecione a loja e o período para consultar",
  emptyResult: "Nenhuma troca encontrada para os filtros selecionados",
  pageSizeLabel: "Linhas por página",
  previousPage: "Anterior",
  nextPage: "Próximo",
  exchangeSingular: "troca",
  exchangePlural: "trocas",
} as const;

export const PAGE_SIZE_OPTIONS: readonly number[] = [10, 20, 50, 100];

export enum ExchangeStatus {
  PENDENTE = 0,
  EFETIVADA = 1,
  CANCELADA = 2,
}

export interface FilterOption {
  readonly value: string;
  readonly label: string;
}

export const EXCHANGE_STATUS_OPTIONS: readonly FilterOption[] = [
  { value: String(ExchangeStatus.PENDENTE), label: "Pendente" },
  { value: String(ExchangeStatus.EFETIVADA), label: "Efetivada" },
  { value: String(ExchangeStatus.CANCELADA), label: "Cancelada" },
];

export const MAX_PERIOD_DAYS = 31;

export const GLOBALLY_HANDLED_STATUS: ReadonlySet<number> = new Set([
  401, 403, 423,
]);

export const STORE_EXCHANGE_MESSAGES = {
  MISSING_FILTERS: {
    description: "Selecione a loja e o período antes de consultar",
    variant: "destructive" as const,
  },
  PERIOD_TOO_LONG: {
    description: `O período não pode ultrapassar ${MAX_PERIOD_DAYS} dias`,
    variant: "destructive" as const,
  },
  EMPTY_EXPORT: {
    description: "Nenhuma troca para exportar no período selecionado",
  },
  EXPORT_QUEUED: {
    description:
      "Estamos gerando sua exportação. Ela chegará em {email} e nas suas notificações.",
  },
  EXPORT_ERROR: {
    description: "Não foi possível gerar o Excel",
    variant: "destructive" as const,
  },
};

export const RETENTION_WARNING =
  "A loja não guarda trocas anteriores a {date}. O período selecionado começa antes dessa data e pode vir incompleto.";

export const STORE_EXCHANGE_FILE_PREFIX = "consulta-trocas";
export const EXCEL_EXTENSION = "xlsx";
export const DEFAULT_PER_PAGE = 50;
export const FIRST_PAGE = 1;
export const ISO_DATE_LENGTH = 10;
export const DISPLAY_DATE_FORMAT = "dd/MM/yyyy";
export const EMPTY_CELL = "-";

export const CONTROL_NUMBER_MAX_LENGTH = 11;
export const CUSTOMER_DOCUMENT_MAX_LENGTH = 14;
export const OPERATOR_MAX_LENGTH = 10;

export const CURRENCY_LOCALE = "pt-BR";
export const CURRENCY_OPTIONS: Intl.NumberFormatOptions = {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
};

export const EMAIL_PLACEHOLDER = "{email}";

export const PAGINATION_ELLIPSIS = "...";

export const NAVIGATE_BUTTON_CLASS =
  "cursor-pointer px-3 py-1.5 bg-[#2b0c1a] text-white hover:underline " +
  "disabled:cursor-not-allowed disabled:bg-[#d9dae0] disabled:text-[#8d91a2] " +
  "disabled:no-underline";

export const PAGE_CELL_CLASS =
  "flex justify-center px-1.5 py-2 min-w-[29px] border border-l-0 border-t-0 " +
  "border-[#dcdce3]";

export const PAGE_CELL_SELECTED_CLASS = "bg-[#f4c83e]";

export const PAGE_CELL_CLICKABLE_CLASS = "cursor-pointer hover:underline";
